/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Images
 */

import { WineIcon } from '../../../../../images/icons/AssetsIcons/Wine'
import { CasksIcon } from '../../../../../images/icons/AssetsIcons/Casks'
import { BinIcon } from '../../../../../images/icons/Bin/Bin'
import { PlusIcon } from '../../../../../images/icons/Plus/Plus'
/**
 *     Import
 *     - CSS
 */
import '../../styles/Step03.css'

const REGEXP = '^(?!(?:^[-+]?[0.]+(?:[Ee]|$)))(?!(?:^-))(?:(?:[+-]?)(?=[0123456789.])' +
    '(?:(?:(?:[0123456789]+)(?:(?:[.])(?:[0123456789]*))?|(?:(?:[.])(?:[0123456789]+))))' +
    '(?:(?:[Ee])(?:(?:[+-]?)(?:[0123456789]+))|))$'

/**
 * AgreedTable class
 *
 * @class AgreedTable
 * @extends {React.Component<any, any>}
 */
class AgreedTable extends React.Component<any, any> {

    /**
     * Creates an instance of AgreedTable.
     *
     * @param {*} props
     * @memberof AgreedTable
     */
    constructor(props: any) {
        super(props)

        this.state = {
            tableItems: props.tableItems,
            // updateParentStateItems: props.updateParentStateItems,
        }

    }

    /**
     * If there are new props from the father,
     * would update its current state with the new data
     *
     * @param {*} nextProps
     * @memberof AgreedTable
     */
    componentWillReceiveProps(nextProps: any) {
        this.setState({
            tableItems: nextProps.tableItems,
        })
    }

    /**
     * Dynamic Field group
     * Handle the Add new row action request
     * After changing it on the component state, call setFieldValue() to set the values on the form
     */
    handleDynamicAdd = (type) => {
        const tableItems = this.state.tableItems
        const typeIndex = tableItems.findIndex(el => el.type === type)
        if (typeIndex !== -1) {
            const newItem = { title: '', agreed_value: '0', insured: 0 }
            tableItems[typeIndex].items = tableItems[typeIndex].items.concat([newItem])
            this.setState({ tableItems })
        }
    }

    /**
     * Dynamic Field group
     * Handle the remove row
     * After changing it on the component state, call setFieldValue() to set the values on the form
     *
     * @param  {string} type [category]
     * @param  {integer} index [row index]
     */
    handleDynamicRemove = (type, index) => {
        const tableItems = this.state.tableItems
        const typeIndex = tableItems.findIndex(el => el.type === type)
        if (typeIndex !== -1) {
            tableItems[typeIndex].items = tableItems[typeIndex].items.filter((el, idx) => idx !== index)
            this._updateStateItem(tableItems)
        }
    }

    /**
     * Dynamic Field group
     * Input text fields onChange trigger call this function
     * handleDynamicChange() is called to help setting the values on component state.
     *
     * @param  {string} type [category]
     * @param  {integer} index [row index]
     */
    handleDynamicValueChange = (type, index) => (event) => {
        const tableItems = this.state.tableItems
        const typeIndex = tableItems.findIndex(el => el.type === type)
        if (typeIndex !== -1 && tableItems[typeIndex].items[index]) {
            const item = tableItems[typeIndex].items[index]
            if (event.target.name === 'title') {
                item.title = event.target.value
                this._updateStateItem(tableItems)
            } else if (event.target.name === 'value') {
                if (event.target.value !== '') {
                    item.agreed_value = event.target.value.replace(/^-*/, '').replace(/^0+/, '')
                    if (item.agreed_value === '') {
                        item.agreed_value = '0'
                    }
                    item.insured = parseFloat(item.agreed_value)
                    this._updateStateItem(tableItems)
                } else {
                    item.agreed_value = '0'
                    item.insured = Number(0)
                    this._updateStateItem(tableItems)
                }
            }
        }
    }

    /**
     * It creates all the elements to show in the table
     *
     * @memberof AgreedTable
     */
    _createAgreedTableContent = () => {
        return this.state.tableItems.map((item) => {
            let myCurrency = item.items.reduce((sum, oneItem) => sum + oneItem.insured, 0)
            return (
                <div key={'agreed' + item.type}>
                    <div className="table__content">
                        <div className="table__50-item">
                            <div className="table__50-item--row15 font_0">
                                {this._getMatchingIcon(item.type)}
                            </div>
                            <div className="table__50-item--row85">
                                {item.text}
                            </div>
                            <div className="exclude_text">
                                {item.type === 'preciousMetalsCoinsMedals' ?
                                    'excludes jewellery' : null}
                                {item.type === 'clocks' ?
                                    'excludes watches' : null}
                            </div>
                        </div>
                        <h4 className="table__10-item">
                            {item.items.length}
                        </h4>
                        <h4 className="table__30-item">
                            {/* £{item.items.reduce((sum, oneItem) => sum + oneItem.insured, 0).toFixed(2)} */}
                            {(myCurrency).toLocaleString('en-GB', {
                                style: 'currency',
                                currency: 'GBP',
                            })}
                        </h4>
                        <div className="table__10-item">
                            <button
                                type="button"
                                onClick={() => this.handleDynamicAdd(item.type)}
                                className="quote__form__dynamic--add"
                            >
                                <PlusIcon />
                            </button>
                        </div>
                    </div>

                    <div>
                        {item.items.map((oneItem, idx) => (
                            <div className="table__content" key={item.type + idx}>
                                <div className="table__60-item">
                                    <div className="input full">
                                        <input
                                            name="title"
                                            placeholder="title"
                                            type="text"
                                            onChange={this.handleDynamicValueChange(item.type, idx)}
                                            value={oneItem.title}
                                        />
                                    </div>
                                </div>

                                <div className="table__30-item">
                                    <div className="input">
                                        <div className="input__pound">
                                            &pound;
                                        </div>
                                        <input
                                            type="number"
                                            name="value"
                                            onChange={this.handleDynamicValueChange(item.type, idx)}
                                            value={oneItem.agreed_value}
                                            placeholder="0"
                                            step="any"
                                            min="0"
                                            pattern={REGEXP}
                                        />
                                    </div>
                                </div>

                                <div className="table__10-item">
                                    <button
                                        type="button"
                                        onClick={() => this.handleDynamicRemove(item.type, idx)}
                                        className="quote__form__dynamic--remove"
                                    >
                                        <BinIcon color={'#fca61b'} />
                                    </button>
                                </div>

                            </div>
                        ))}
                    </div>
                </div>
            )
        })
    }

    /**
     * Generates the corresponding Icon ot the item
     * passed as parameter
     *
     * @param {String} item the item to show
     * @memberof AgreedTable
     */
    _getMatchingIcon = (item: String) => {
        switch (item) {
            case 'collectiblesMemorabilia':
                return <CasksIcon />

            case 'fineWinesAndSpirits':
                return <WineIcon />

            default:
                return ''
        }
    }

    /**
     * Updates a new item from the tableItems
     * in the state of the component
     *
     * @param {*} itemToUpdate
     * @memberof AgreedTable
     */
    _updateStateItem(tableItems: any[]) {
        this.props.updateParentStateItems(tableItems)
        this.setState({ tableItems })
    }

    render() {
        return (
            <div>
                <div className="table__titles shadow">
                    <div className="table__50-item">
                        Category of insured item
                    </div>
                    <div className="table__10-item">
                        Total items
                    </div>
                    <div className="table__20-item">
                        Total value agreed
                    </div>
                </div>
                {this._createAgreedTableContent()}
            </div>
        )
    }
}

export default AgreedTable



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step03w/components/AgreedTable.tsx